export const sideNavTourDescriptions = {
    dashboard: "Start here for your main dashboards and daily operational visibility.",
    assets: "View and manage assets from this section.",
    workflows: "Track and manage workflow items here.",
    loads: "Use this area to manage loads and transportation activity.",
    lotmgmt: "Access lots, lot operations, and inventory tools here.",
    billing: "Review invoices, reports, and billing configuration here.",
    admin: "Manage users, forms, vendors, reservations, and other admin settings here.",
    tenants: "Manage tenant-level SaaS settings here.",
};